export default "/wp-content/themes/onnit/script/cart/dist/stgBg-50e63120.jpg";